import styled from 'styled-components';
import { MultiFileDropZone } from '@dealstack/frontend/shared/components/MultiFileDropZone/MultiFileDropZone';

export const SelectedFileItemContainer = styled.div`
	display: flex;
	width: 17.5rem;
	flex-direction: column;
	align-items: flex-start;
	padding: 0.5rem;
	justify-content: space-between;
	gap: 0.25rem;
	border-radius: 0.25rem;
	border: 1px solid ${(props) => props.theme.color.greys[200]};
`;

export const IconContainer = styled.div<{ $justify: string }>`
	display: flex;
	justify-content: ${({ $justify }) => $justify ?? 'flex-end'};
	width: 100%;
`;

export const StyledMultiFileDropZone = styled(MultiFileDropZone).attrs({
	textButton: true,
	icon: null,
	height: '11rem',
})`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const UnclassifiedContainer = styled.div`
	width: 100%;
`;

export const Container = styled.div`
	width: 100%;
`;
